module.exports = __webpack_public_path__ + "img/role-2.5fd78044.png";